import { balance } from './balance.reducer';

export default {
  balance
}